import Badge from "@/components/UI/Badge/Badge";
import classNames from "classnames";
import DifferenceProgressBar from "./DifferenceProgressBar";
import Card from "@/components/UI/Card/Card";
import { JobChange } from "@webmonitoring/vp-common/Types/Apis/JobGet";
import { toRelativeDate } from "@/utils/date";
import SummaryCard from "./SummaryCard";
import Image from "next/image";
import { useState } from "react";

type ChangesDetectedCardProps = {
  historyItem: JobChange;
  page: any;
  section: any;
};

const ChangesDetectedCard = ({ historyItem, page, section }: ChangesDetectedCardProps) => {
  const [imageError, setImageError] = useState("");

  return (
    <Card className="flex w-full items-center border-vpGray-300 px-8 py-6" color="neutral0" rounded="medium">
      <div
        className={classNames(
          "absolute -left-[15px] z-10 border-y-[15px] border-l-0 border-r-[15px] border-solid border-y-transparent border-r-vpGray-300"
        )}
      />
      <div
        className={classNames(
          "absolute -left-[14px] z-10 border-y-[15px] border-l-0 border-r-[15px] border-solid border-y-transparent border-r-white"
        )}
      />
      <div className="flex w-full items-center justify-between gap-6">
        <div className="flex flex-1 flex-col gap-4">
          <div className="flex w-full justify-between">
            <div className="flex items-center gap-1">
              <div className="text-sm font-bold uppercase tracking-tight">{section?.Check}</div>
              <div className="text-sm uppercase">
                {toRelativeDate({
                  date: new Date(historyItem.created).getTime(),
                  locale: page?.attributes?.locale,
                })}
              </div>
            </div>
            <Badge
              className="border-none bg-vpTeal-100 px-2  text-sm uppercase tracking-tight text-vpTeal-500"
              color="success500"
              size="small"
              variant="solid"
            >
              {section?.ChangeDetected}
            </Badge>
          </div>
          <div className="flex gap-4">
            <div className="flex flex-1 flex-col items-start gap-4">
              <SummaryCard historyItem={historyItem} page={page} section={section} />
              {historyItem.PercentDifference && (
                <DifferenceProgressBar className="w-full" section={section} historyItem={historyItem} />
              )}
            </div>
            <div className="relative h-[159px] w-[225px] shrink-0 items-center justify-center overflow-hidden rounded-lg border border-vpGray-300">
              {imageError ? (
                <Image
                  alt={`Check dated ${historyItem.created} thumbnail error image`}
                  className="absolute !top-[7px]"
                  fill
                  src="/_public-pages-service/dizzy-illustration.svg"
                />
              ) : (
                <Image
                  alt={`Check dated ${historyItem.created} thumbnail image`}
                  fill
                  onError={() => {
                    setImageError("error");
                  }}
                  src={historyItem.thumb_diff_90 ?? ""}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ChangesDetectedCard;
